import { useState } from 'react'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { ArrowBack } from '@mui/icons-material'
import { CircularProgress, Grid } from '@mui/material'
import { ROUTES } from '../../../constants'
import { WorkspaceSections } from 'lib/enums/shared.enums'
import { selectWorkspaceActiveTab } from 'lib/helpers/selectors'
import { useAppSelector } from 'store/hooks'
import Button from 'components/Shared/Button/Button'
import WorkspaceDetailsContainer from 'containers/Workspaces/WorkspaceDetailsContainer/WorkspaceDetailsContainer'
import './styles.scss'

const WorkspaceDetailsScreen = () => {
  const navigate = useNavigate()

  const [params] = useSearchParams()

  const id = Number(params.get('id'))

  const activeTab = useAppSelector(selectWorkspaceActiveTab)

  const [fetching, setFetching] = useState(false)

  const onRouteChange = (action: string, idGo: number = 0) => {
    if (action === 'back') navigate(ROUTES.WORKSPACES)
    if (action === 'error') navigate(ROUTES.WORKSPACES, { replace: true })
    if (action === 'edit' && activeTab === WorkspaceSections.EMISORES)
      navigate(`${ROUTES.RAZON_SOCIAL_DETAILS}?id=${idGo}&ws=${id}`, {
        state: { from: `${ROUTES.WORKSPACE_DETAILS}?id=${id}` },
      })
    if (action === 'add' && activeTab === WorkspaceSections.EMISORES)
      navigate(`${ROUTES.ADD_RAZON_SOCIAL}?ws=${id}`, {
        state: { from: `${ROUTES.WORKSPACE_DETAILS}?id=${id}` },
      })
  }

  if (!id) {
    return <Navigate to={ROUTES.HOME} replace />
  }

  return (
    <>
      <Grid container spacing={0} className="workspace-details-screen">
        <Grid item xs={12} className="actions-container">
          <Button
            id="cancelEditWorkspaceBtn"
            variant="hover"
            color="secondary"
            startIcon={<ArrowBack />}
            onClick={() => onRouteChange('back')}>
            Volver
          </Button>
          {fetching && <CircularProgress size={30} color="primary" />}
        </Grid>
        <Grid item xs={12}>
          <WorkspaceDetailsContainer
            id={id}
            onRedirect={onRouteChange}
            onFetching={setFetching}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default WorkspaceDetailsScreen
